/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { cn } from "tailwind-variants";
import GangSheetBuilder from "./GangSheetBuilder.vue";
import { useDtfStore } from "./store";
import "./GangSheetBuilderContainer.scss";

export default function GangSheetBuilderContainer({ ...restProps }) {
  const store = useDtfStore();
  const { className: attrClassName, ...otherAttrs } = restProps;

  function showGangSheetBuilderFeature() {
    // @ts-expect-error TS(4111): Property 'showGangSheetBuilderFeature' comes from ... Remove this comment to see the full error message
    return store.showGangSheetBuilderFeature;
  }

  function showGangSheetBuilder() {
    // @ts-expect-error TS(4111): Property 'showGangSheetBuilder' comes from an inde... Remove this comment to see the full error message
    return store.showGangSheetBuilder;
  }

  function setShowGangSheetBuilder(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.setShowGangSheetBuilder(...args);
  }

  function handleGangSheetBuilder() {
    setShowGangSheetBuilder(true);
    submitDtfEvent("gangsheet_builder_opened", {});
  }

  return (
    <>
      {showGangSheetBuilderFeature() ? (
        <div className={cn("gang-sheet-builder-builder-container", attrClassName)} {...otherAttrs}>
          {showGangSheetBuilder() ? <GangSheetBuilder data-testid="gang-sheet-builder" /> : null}
          <span className="gang-sheet-builder-builder-container__new-icon">🔥 NEW!</span>
          <button
            className="gang-sheet-builder-builder-container__button"
            type="button"
            onClick={e => {
              e.stopPropagation();
              handleGangSheetBuilder();
            }}
            data-testid="gang-sheet-builder-builder-container-button"
          >
            {" "}
            Build a Gang Sheet{" "}
          </button>
        </div>
      ) : null}
    </>
  );
}
